import { useQuery } from '@tanstack/react-query';
import { Foreground } from '../models';
import QUERY_KEYS from '../utils/QueryKeys';

export default function useForegrounds() {
  return useQuery([QUERY_KEYS.foregrounds], () => (
    Foreground
      .where({ senior: true })
      .all()
      .then((res) => res.data)
  ), { placeholderData: [] });
}
